import { render, staticRenderFns } from "./ShofurSecure.vue?vue&type=template&id=3e50e06c&scoped=true"
var script = {}
import style0 from "./ShofurSecure.vue?vue&type=style&index=0&id=3e50e06c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e50e06c",
  null
  
)

export default component.exports